import React from 'react';
import TlkEnergyLogo from '../logos/tlkEnergy';
import TlkLogo from '../logos/tlk';

type Props = {
  showSimpleVersion?: boolean;
};

const Logo = ({ showSimpleVersion = false }: Props) => {
  return showSimpleVersion ? <TlkLogo /> : <TlkEnergyLogo />;
};

export default Logo;
